import React, { useState, useEffect, useMemo } from 'react';
import PurchasesNav from '../components/PurchasesNav';
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  CircularProgress,
  InputAdornment,
  Chip,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
import { supplierDirectoryService } from '../services/api';

function SuppliersPage() {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  const load = async () => {
    try {
      setLoading(true);
      const res = await supplierDirectoryService.getAll({ is_active: true });
      const rows = Array.isArray(res.data?.results) ? res.data.results : Array.isArray(res.data) ? res.data : [];
      setList(rows);
    } catch (e) {
      console.error(e);
      alert('Помилка завантаження постачальників');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return list;
    return list.filter(
      (s) =>
        (s.name || '').toLowerCase().includes(q) ||
        (s.edrpou || '').toLowerCase().includes(q) ||
        (s.address || '').toLowerCase().includes(q),
    );
  }, [list, search]);

  return (
    <Box>
      <PurchasesNav />
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h4">Постачальники</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate('/suppliers/new')}>
          Додати постачальника
        </Button>
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Довідник контрагентів для закупівель (реквізити, банк, договір). У закупівлі можна обрати запис з довідника —
        за аналогією до замовників у замовленнях клієнтів.
      </Typography>
      <TextField
        size="small"
        placeholder="Пошук за назвою, ЄДРПОУ, адресою…"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        sx={{ mb: 2, minWidth: 320 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
      />
      {loading ? (
        <Box display="flex" justifyContent="center" p={4}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell>Назва</TableCell>
                <TableCell>ЄДРПОУ</TableCell>
                <TableCell>Телефон</TableCell>
                <TableCell align="right" />
              </TableRow>
            </TableHead>
            <TableBody>
              {filtered.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4}>
                    {list.length === 0 ? 'Немає постачальників — натисніть «Додати».' : 'Нічого не знайдено.'}
                  </TableCell>
                </TableRow>
              ) : (
                filtered.map((s) => (
                  <TableRow key={s.id} hover>
                    <TableCell>
                      {s.name}
                      {!s.is_active && (
                        <Chip size="small" label="неактивний" sx={{ ml: 1 }} />
                      )}
                    </TableCell>
                    <TableCell>{s.edrpou || '—'}</TableCell>
                    <TableCell>{s.phone || '—'}</TableCell>
                    <TableCell align="right">
                      <Button
                        size="small"
                        startIcon={<EditIcon />}
                        onClick={() => navigate(`/suppliers/${s.id}`)}
                      >
                        Картка
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}

export default SuppliersPage;
